import { AxiosError } from "axios";
import qs from "query-string";
import { useQuery } from "react-query";
import { ConversationAllResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useGetAllConversation = (
  pageTable: number,
  resultsPerPage: number = 20,
  conversationName: string
) => {
  const newSkip = (pageTable - 1) * resultsPerPage;
  return useQuery<any, AxiosError<any>, ConversationAllResponse>(
    ["conversation", "all", pageTable],
    async () => {
      const query: Record<string, any> = {
        skip: newSkip,
        limit: resultsPerPage,
        name: ""
      };

      const data = await axiosClient.get<ConversationAllResponse>(
        `/conversation/getAll?${qs.stringify(query)}`
      );
      return data.data;
    },
    {
      staleTime: Infinity,
      enabled: false,
      keepPreviousData: true,
    }
  );
};
